import { Module } from '../Module';
import { DeleteMetricRequest } from '../ServerApi/requests/DeleteMetricRequest';
import { IResult } from '../ServerApi/types/IResponse';
import { MetricAllowedActions } from '../ServerApi/types/MetricAllowedActions';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { IActionResource } from './Resource';

/*
 * This is the resource in vizportal's webclient api.
 * It is different than the resource, `Metrics.ts`, which is in the Metrics rest api on aws.
 */
export class MetricsResource implements IActionResource<MetricAllowedActions> {

  public static $inject = [
    '$q',
    'ErrorNotifyingServer'
  ];

  constructor(
    private $q: ng.IQService,
    private ErrorNotifyingServer: ErrorNotifyingServer,
  ) { }

  public actions(id: string): ng.IPromise<MetricAllowedActions> {
    return this.$q.resolve({del: true});
  }

  public del(metricLuid: string): ng.IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequest(new DeleteMetricRequest(metricLuid));
  }
}

Module.instance().service('MetricsResource', MetricsResource);
